/* ... existing imports ... */
import React from 'react'
import { motion } from 'framer-motion'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiTrendingUp, FiTrendingDown } = FiIcons

const RecentTrades = ({ trades }) => {
  const navigate = useNavigate()

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Recent Trades</h3>
        <button 
          onClick={() => navigate('/journal')}
          className="text-blue-600 hover:text-blue-700 text-sm font-medium transition-colors"
        >
          View All
        </button>
      </div>
      <div className="space-y-4">
        {trades.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <p>No trades recorded yet</p>
            <button 
              onClick={() => navigate('/journal', { state: { openForm: true } })}
              className="mt-2 text-blue-600 hover:text-blue-700 font-medium hover:underline transition-all"
            >
              Add your first trade
            </button>
          </div>
        ) : (
          trades.slice(0, 5).map((trade, index) => (
            <motion.div 
              key={trade.id} 
              initial={{ opacity: 0, x: 20 }} 
              animate={{ opacity: 1, x: 0 }} 
              transition={{ delay: index * 0.1 }} 
              className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => navigate('/journal')}
            >
              <div className="flex items-center space-x-3">
                <div className={`p-2 rounded-lg ${(trade.pnl || 0) >= 0 ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                  <SafeIcon icon={(trade.pnl || 0) >= 0 ? FiTrendingUp : FiTrendingDown} className="h-4 w-4" />
                </div>
                <div>
                  <p className="font-medium text-gray-900">
                    {trade.symbol || 'Unknown'} - {trade.side?.toUpperCase() || 'Unknown'}
                  </p>
                  <p className="text-sm text-gray-500">
                    {trade.entry_time ? format(new Date(trade.entry_time), 'MMM dd, HH:mm') : 'No date'}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className={`font-semibold ${(trade.pnl || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {(trade.pnl || 0) >= 0 ? '+' : '-'}Rp {Math.abs(trade.pnl || 0).toLocaleString('id-ID')}
                </p>
                <p className="text-sm text-gray-500">
                  {trade.setup_type || 'No setup'}
                </p>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  )
}

export default RecentTrades